/* eslint-disable */
import React, { useState } from 'react';
import Pagination from '@cashew/pagination';
import Box from '@cashew/box';
import List from '@cashew/list';
import Title from '@cashew/title';
import Button from '@cashew/button';
import { order } from '@cashew/types';
import cn from 'classnames';
import RenewalItem from './RenewalItem';
import OrderFilter from './OrdersFilter';

import './index.css';

const ns = 'renewals';

/**
 * Subscriptions Page Container
 */
export default ({
  t,
  useSelector,
  type = 'customer',
  history,
  dispatch,
  isOffline = false,
  handleListItemClick = undefined,
}: any) => {
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [list, setList] = useState<Array<order.OrderType>>([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showFilter, setShowFilter] = useState(false);

  const headers = [
    { key: 'name', value: 'Customer name', hide: type === 'customer' },
    { key: 'storeName', value: 'Store name', hide: type !== 'customer' },
    { key: 'date', value: 'Order date' },
    { key: 'id', value: 'Order ID' },
    { key: 'orderReference', value: 'Merchant order code', hide: !isOffline },
    { key: 'status', value: 'Status' },
    {
      key: 'LastActivityDate',
      value: 'Last activity date',
      hide: type === 'customer',
    },
    { key: 'nextPaymentDate', value: 'Next payment date' },
    { key: 'totalAmount', value: 'Amount' },
  ];

  return (
    <div className={ns}>
      <Title>
        <span>Subscriptions</span>
        <span>
          <Button
            extraClass="blue show-filter-btn"
            onClick={() => setShowFilter(!showFilter)}
          >
            <div className="btn-with-icon">
              <img src="/fillter.svg" alt="filter" />
              Filters
            </div>
          </Button>
        </span>
      </Title>
      <div className={cn({ 'hide-filter': !showFilter })}>
        <OrderFilter
          setLoading={setLoadingOrders}
          useSelector={useSelector}
          page="subscription"
          type={type}
          setRecords={setRecords}
          setList={setList}
          pageSize={pageSize}
          pageNumber={pageNumber}
          history={history}
          dispatch={dispatch}
          records={records}
          setPageNumber={setPageNumber}
        />
      </div>
      <div style={{ height: '16px' }} />
      <Box withHeader>
        <div>
          <div className={`${ns}__headers`}>
            {headers.map(
              (header, index) =>
                !header.hide && <p key={String(index)}>{header.value}</p>
            )}
          </div>
          <List
            data={list}
            component={(props: any) => RenewalItem({ ...props, isOffline })}
            context="subscriptions"
            isLoading={loadingOrders}
            t={t}
            handleListItemClick={handleListItemClick}
          />
          <Pagination
            records={records}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            changePageSize={setPageSize}
          />
        </div>
      </Box>
    </div>
  );
};
